// extracted by mini-css-extract-plugin
export default {"appleBtn":"aFef_U","white":"LR8EDJ","appleIcon":"BhTcf5","appleBtnContainer":"yGln7N","error":"ssxR1c"};